import { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { AppBreadcrumb } from "./AppBreadCrumb";
import { Navbar } from "./Navbar";

interface LayoutProps {
    children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
    const location = useLocation();
    const breadCrumbPages = ["/about", "/blog", "/contact"];
    const showBreadcrumb = breadCrumbPages.some(
        (page) => location.pathname === page || location.pathname.startsWith(page)
    );

    return (
        <div className="flex flex-col min-h-screen">
            <Navbar />
            {showBreadcrumb && (
                <div className="max-w-7xl mx-auto px-4 py-4">
                    <AppBreadcrumb />
                </div>
            )}

            <main className="flex-1 p-0 sm:p-4 lg:p-6">{children}</main>
        </div>
    );
}
